/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// orchestration
import Firebase from "orchestration/firebase-library/Firebase.js";

// utils
import LoggerUtils from "utils/logger-utils/LoggerUtils.js";
import ValidationUtils from "utils/validation-utils/ValidationUtils.js";

class StorageService {

  /**
  * @param {String} imageStoragePath
  * @returns {Promise<String>} imageUrl
  */
  static async getImageUrl(imageStoragePath) {
    if(
      ValidationUtils.string(imageStoragePath) &&
      String(imageStoragePath) !== String("new") &&
      String(imageStoragePath) !== String("not-set")
    ) {
      return new Promise((resolve) => {
        Firebase.Storage.getDownloadUrl(imageStoragePath)
        .then((downloadUrl) => resolve(downloadUrl))
        .catch((error) => {
          LoggerUtils.error(`Failed to get image storage URL: "${imageStoragePath}".`, error);
          resolve(imageStoragePath);
        });
      });
    }
    else {
      return imageStoragePath;
    }
  }

  /**
  * @param {Image} image
  */
  static async getImageUrls(image) {
    if(ValidationUtils.imageSources(image.getSources())) {
      await Promise.all(Object.entries(image.getSources()).map(async ([key, value]) => {
        image.urls[key] = await StorageService.getImageUrl(value);
      }));
    }
  }

  /**
  * @param {String} transactionId
  * @param {String} fileName
  * @param {Object} payload
  * @param {Object} metadata
  * @param {Function} onProgress
  * @returns {Promise}
  */
  static async upload(transactionId, fileName, payload, metadata, onProgress) {
    const apiPathIngest = Firebase.getApiPaths().ingest;
    return Firebase.Storage.upload(
      fileName,
      `${apiPathIngest}/${transactionId}`,
      payload,
      metadata,
      onProgress
    );
  }

}
export default StorageService;
